var bittoelatings_f = [{
        rule: "vertakkings:create",
        bitmask: "1",
        blok: 5,
        beskrywing: "Skep van vertakkings",
        groepe: ["vertakkings", "setup"]
    },
    {
        rule: "vertakkings:read",
        bitmask: "2",
        blok: 5,
        beskrywing: "Lees van vertakkings",
        groepe: ["vertakkings", "setup"]
    },
    {
        rule: "vertakkings:update",
        bitmask: "4",
        blok: 5,
        beskrywing: "Veranderinge aan vertakkings",
        groepe: ["vertakkings", "setup"]
    },
    {
        rule: "vertakkings:delete",
        bitmask: "8",
        blok: 5,
        beskrywing: "Verwydering van vertakkings",
        groepe: ["vertakkings", "setup"]
    },
    {
        rule: "spdienste:create",
        bitmask: "16",
        blok: 5,
        beskrywing: "Skep van dienste",
        groepe: ["spdienste", "setup"]
    },
    {
        rule: "spdienste:read",
        bitmask: "32",
        blok: 5,
        beskrywing: "Lees van dienste",
        groepe: ["spdienste", "setup"]
    },
    {
        rule: "spdienste:update",
        bitmask: "64",
        blok: 5,
        beskrywing: "Veranderinge aan dienste",
        groepe: ["spdienste", "setup"]
    },
    {
        rule: "spdienste:delete",
        bitmask: "128",
        blok: 5,
        beskrywing: "Verwydering van dienste",
        groepe: ["spdienste", "setup"]
    },
    {
        rule: "diensverskaffer:create",
        bitmask: "256",
        blok: 5,
        beskrywing: "Skep van 'n diensverskaffer",
        groepe: ["diensverskaffer", "setup"]
    },
    {
        rule: "diensverskaffer:read",
        bitmask: "512",
        blok: 5,
        beskrywing: "Lees van diensverskaffer",
        groepe: ["diensverskaffer", "setup"]
    },
    {
        rule: "diensverskaffer:update",
        bitmask: "1024",
        blok: 5,
        beskrywing: "Verander diensverskaffer",
        groepe: ["diensverskaffer", "setup"]
    },
    {
        rule: "diensverskaffer:delete",
        bitmask: "2048",
        blok: 5,
        beskrywing: "Verwyder 'n diensverskaffer",
        groepe: ["diensverskaffer", "setup"]
    },
    {
        rule: "versoeke:create",
        bitmask: "4096",
        blok: 5,
        beskrywing: "Aktiveer versoek",
        groepe: ["versoeke", "setup"]
    },
    {
        rule: "versoeke:read",
        bitmask: "8192",
        blok: 5,
        beskrywing: "Lees versoeke",
        groepe: ["versoeke", "setup"]
    },
    {
        rule: "versoeke:update",
        bitmask: "16384",
        blok: 5,
        beskrywing: "Verander versoeke",
        groepe: ["versoeke", "setup"]
    },
    {
        rule: "versoeke:delete",
        bitmask: "32768",
        blok: 5,
        beskrywing: "Deaktiveer versoeke",
        groepe: ["versoeke", "setup"]
    },
    {
        rule: "diensverskaffers:visit",
        bitmask: "65536",
        blok: 5,
        beskrywing: "Toegang tot diensverskaffers opstelling bladsy",
        groepe: ["diensverskaffers", "visit"]
    },
    {
        rule: "vertakkings:visit",
        bitmask: "131072",
        blok: 5,
        beskrywing: "Toegang tot vertakkings opstelling bladsy",
        groepe: ["vertakkings", "visit"]
    },
    {
        rule: "dienste:visit",
        bitmask: "262144",
        blok: 5,
        beskrywing: "Toegang tot dienste opstelling bladsy",
        groepe: ["dienste", "visit"]
    },
    {
        rule: "versoeke:visit",
        bitmask: "524288",
        blok: 5,
        beskrywing: "Toegang tot die versoeke bladsy",
        groepe: ["versoeke", "visit"]
    },
    {
        rule: "kliente:visit",
        bitmask: "1048576",
        blok: 5,
        beskrywing: "Toegang tot die kliente bladsy",
        groepe: ["kliente", "visit"]
    },
    {
        rule: "kliente:read",
        bitmask: "2097152",
        blok: 5,
        beskrywing: "Lees van kliente",
        groepe: ["kliente", "read"]
    },
];

export default bittoelatings_f;